// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Button, Grid, Typography } from "@mui/material";
// import GamesIcon from "@mui/icons-material/Games";

// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";

// import httpclient from "../../../../Utils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";

// import { getColumns } from "./columns";
// import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
// import { useDeliveryReason } from "../../../../Hooks/useDeliveryReason";

// export default function DeliveryReasons() {
//   const [selectedReason, setSelectedReason] = useState(null);
//   const [changeStatus, setChangeStatus] = useState(false);
//   const [allowAdd,setAllowAdd] = useState(1);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [sortModel, setSortModel] = useState([]);
//   const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);

//   const navigate = useNavigate();
//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();

//   const { deliveryReasons, loading, rowCount, refreshDeliveryReasons } =
//     useDeliveryReason({
//       pagination: paginationModel,
//       sorting: sortModel,
//     });

//   const handleChangeStatus = async () => {
//     setChangeStatus(true);
//     const API_URL = `/delivery/order-reason/status/${selectedReason.id}`;

//     try {
//       const { data } = await httpclient.post(API_URL);

//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedReason(null);
//         setOpenStatusChangeModal(false);
//          if (data.allow_add !== undefined) {
//           setAllowAdd(data.allow_add);
//         }
//         refreshDeliveryReasons(); // Use the hook's refresh function
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       console.log(error, "error changing status");
//       handleApiError(error);
//     } finally {
//       setChangeStatus(false);
//     }
//   };

//   const handleAddReason = () => {
//     navigate("/delivery/reasons/add");
//   };

//   const handleEdit = (reason) => {
//     setSelectedReason(reason);
//     navigate(`/delivery/reasons/edit/${reason.id}`, {
//       state: { reason },
//     });
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const columns = getColumns(
//     setSelectedReason,
//     setOpenStatusChangeModal,
//     handleEdit
//   );

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "24px 16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid
//           container
//           spacing={2}
//           alignItems="center"
//           justifyContent="flex-end"
//           mb={2}
//         >
//           <Grid item xs={12} md={6}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Delivery Order Reason
//             </Typography>
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             md={6}
//             display="flex"
//             alignItems="center"
//             justifyContent="flex-end"
//             gap={2}
//           >
//             {allowAdd===1 && (

            
//             <Button
//               variant="contained"
//               sx={{
//                 borderRadius: "4px",
//                 backgroundColor: "#7152F3",
//                 "&:hover": {
//                   backgroundColor: "#5c34fa",
//                 },
//               }}
//               startIcon={<GamesIcon />}
//               onClick={handleAddReason}
//             >
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontSize: "14px",
//                   fontWeight: 500,
//                   textTransform: "none",
//                 }}
//               >
//                 Add New Reason
//               </Typography>
//             </Button>
//             )}
//           </Grid>
//         </Grid>

//         <DataGrid
//           rows={deliveryReasons || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />
//         {openStatusChangeModal && (
//           <StatusChangeConfirmationModal
//             open={openStatusChangeModal}
//             cancel={() => setOpenStatusChangeModal(false)}
//             title="Change Status"
//             item={selectedReason?.reason_name}
//             loading={changeStatus}
//             handleChangeStatus={handleChangeStatus}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// }

// *************************************************************************************************************************************

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Button, Grid, Typography } from "@mui/material";
// import GamesIcon from "@mui/icons-material/Games";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";
// import DeleteConfirmationModal from "./DeleteConfirmationModal";
// import { getColumns } from "./columns";
// import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
// import Filter from "./Filter";

// const INITIAL_FILTER_STATE = {
//   reason_type: "",
// };

// const fieldMappings = {
//   reason_type: ["reason_type", "$contains"],
// };

// export default function DeliveryReasons() {
//   const [selectedReason, setSelectedReason] = useState(null);
//   const [changeStatus, setChangeStatus] = useState(false);
//   const [allowAdd, setAllowAdd] = useState(1);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [sortModel, setSortModel] = useState([]);
//   const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
  
//   // Filter states
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [reasonTypes, setReasonTypes] = useState([]);
//   const [openDeleteModal, setOpenDeleteModal] = useState(false);
// const [deleting, setDeleting] = useState(false);
//   // Data states
//   const [deliveryReasons, setDeliveryReasons] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [rowCount, setRowCount] = useState(0);
//   const [refreshList, setRefreshList] = useState(false);

//   const navigate = useNavigate();
//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();
// const handleDelete = async (reason) => {
//   setSelectedReason(reason);
//   setOpenDeleteModal(true);
// };
//   // Fetch delivery reasons with filters
//   const fetchDeliveryReasons = async (
//     page = 1,
//     pageSize = 20,
//     filters = submittedData,
//     sortInfo = sortModel
//   ) => {
//     setLoading(true);
//     const endpoint = `/delivery/order-reason`;

//     const apiUrl = buildApiQuery(endpoint, {
//       page: page,
//       pageSize: pageSize,
//       filters: filters,
//       sortModel: sortInfo,
//       fieldMappings,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         setDeliveryReasons(data.data || []);
//         setReasonTypes(data.reason_types || []); // Assuming API returns reason types list
//         setRowCount(data.meta?.total || data.count || 0);
//         setRefreshList(false);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };
// const handleConfirmDelete = async () => {
//   setDeleting(true);
//   const API_URL = `/delivery/order-reason/delete/${selectedReason.id}`;

//   try {
//     const { data } = await httpclient.post(API_URL);

//     if (data.status === 200) {
//       showNotification("success", data.message);
//       setOpenDeleteModal(false);
//       setSelectedReason(null);
//       // Refresh the list
//       fetchDeliveryReasons(
//         paginationModel.page + 1,
//         paginationModel.pageSize,
//         submittedData,
//         sortModel
//       );
//     } else {
//       showNotification("error", data.message);
//     }
//   } catch (error) {
//     console.log(error, "error deleting reason");
//     handleApiError(error);
//   } finally {
//     setDeleting(false);
//   }
// };
//   useEffect(() => {
//     fetchDeliveryReasons(
//       paginationModel.page + 1,
//       paginationModel.pageSize,
//       submittedData,
//       sortModel
//     );
//   }, [
//     refreshList,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };

//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: setDeliveryReasons,
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: `/delivery/order-reason`,
//     fieldMappings,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleRemove = (field) => {
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     newFilterData[field] = "";
//     delete newSubmittedData[field];

//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     handleFilter(newFilterData);
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleChangeStatus = async () => {
//     setChangeStatus(true);
//     const API_URL = `/delivery/order-reason/status/${selectedReason.id}`;

//     try {
//       const { data } = await httpclient.post(API_URL);

//       if (data.status === 200) {
//         showNotification("success", data.message);
//         setSelectedReason(null);
//         setOpenStatusChangeModal(false);
//         if (data.allow_add !== undefined) {
//           setAllowAdd(data.allow_add);
//         }
//         fetchDeliveryReasons(
//           paginationModel.page + 1,
//           paginationModel.pageSize,
//           submittedData,
//           sortModel
//         );
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       console.log(error, "error changing status");
//       handleApiError(error);
//     } finally {
//       setChangeStatus(false);
//     }
//   };

//   const handleAddReason = () => {
//     navigate("/delivery/reasons/add");
//   };

//   const handleEdit = (reason) => {
//     setSelectedReason(reason);
//     navigate(`/delivery/reasons/edit/${reason.id}`, {
//       state: { reason },
//     });
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const columns = getColumns(
//     setSelectedReason,
//     setOpenStatusChangeModal,
//     handleEdit,
//      handleDelete 
//   );

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "24px 16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
//           <Grid item xs={12} md={6}>
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Delivery Order Reason
//             </Typography>
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             md={6}
//             display="flex"
//             alignItems="center"
//             justifyContent="flex-end"
//             gap={2}
//           >
//             <img
//               src={filterOpen ? FilterBtnUp : FilterBtn}
//               alt="Filter"
//               style={{ cursor: "pointer" }}
//               onClick={() => setFilterOpen(!filterOpen)}
//             />
//             {allowAdd === 1 && (
//               <Button
//                 variant="contained"
//                 sx={{
//                   borderRadius: "4px",
//                   backgroundColor: "#7152F3",
//                   "&:hover": {
//                     backgroundColor: "#5c34fa",
//                   },
//                 }}
//                 startIcon={<GamesIcon />}
//                 onClick={handleAddReason}
//               >
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     fontSize: "14px",
//                     fontWeight: 500,
//                     textTransform: "none",
//                   }}
//                 >
//                   Add New Reason
//                 </Typography>
//               </Button>
//             )}
//           </Grid>
//         </Grid>

//         <Filter
//           filterOpen={filterOpen}
//           filterData={filterData}
//           handleChangeFilter={handleChangeFilter}
//           handleFilter={onFilterClick}
//           handleClearFilters={handleClearFilters}
//           handleRemove={handleRemove}
//           submittedData={submittedData}
//           reasonTypes={reasonTypes}
//         />

//         <DataGrid
//           rows={deliveryReasons || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />
        
//         {openStatusChangeModal && (
//           <StatusChangeConfirmationModal
//             open={openStatusChangeModal}
//             cancel={() => setOpenStatusChangeModal(false)}
//             title="Change Status"
//             item={selectedReason?.reason_name}
//             loading={changeStatus}
//             handleChangeStatus={handleChangeStatus}
//           />
//         )}
//         {openDeleteModal && (
//   <DeleteConfirmationModal
//     open={openDeleteModal}
//     cancel={() => setOpenDeleteModal(false)}
//     title="Reason"
//     item={selectedReason?.reason_name}
//     loading={deleting}
//     handleDelete={handleConfirmDelete}
//   />
// )}
//       </Box>
//     </Box>
//   );
// }

// **********************************************************************************************************************************

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Grid, Typography } from "@mui/material";
import GamesIcon from "@mui/icons-material/Games";

import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import httpclient from "../../../../Utils";
import { createFilterHandler } from "../../../../Utils/FilterUtils";
import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

import { getColumns } from "./columns";
import StatusChangeConfirmationModal from "./StatusChangeConfirmationModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import Filter from "./Filter";

const INITIAL_FILTER_STATE = {
  reason_type: "",
};

const fieldMappings = {
  reason_type: ["reason_type", "$contains"],
};

export default function DeliveryReasons() {
  const [selectedReason, setSelectedReason] = useState(null);
  const [changeStatus, setChangeStatus] = useState(false);
  const [allowAdd, setAllowAdd] = useState(1);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [sortModel, setSortModel] = useState([]);
  const [openStatusChangeModal, setOpenStatusChangeModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  
  // Filter states
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
  const [submittedData, setSubmittedData] = useState({});
  
  // Data states
  const [deliveryReasons, setDeliveryReasons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [refreshList, setRefreshList] = useState(false);
  const [reasonTypes, setReasonTypes] = useState([]); // Store reason types here

  const navigate = useNavigate();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  // Fetch delivery reasons with filters
  const fetchDeliveryReasons = async (
    page = 1,
    pageSize = 20,
    filters = submittedData,
    sortInfo = sortModel
  ) => {
    setLoading(true);
    const endpoint = `/delivery/order-reason`;

    const apiUrl = buildApiQuery(endpoint, {
      page: page,
      pageSize: pageSize,
      filters: filters,
      sortModel: sortInfo,
      fieldMappings,
    });

    try {
      const res = await httpclient.get(apiUrl);
      const { data } = res;

      if (data.status === 200) {
        setDeliveryReasons(data.data || []);
        setReasonTypes(data.reason_types || []); // Store reason types from API
        setRowCount(data.meta?.total || data.count || 0);
        setAllowAdd(data.allow_add);
        setRefreshList(false);
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeliveryReasons(
      paginationModel.page + 1,
      paginationModel.pageSize,
      submittedData,
      sortModel
    );
  }, [
    refreshList,
    paginationModel.page,
    paginationModel.pageSize,
    sortModel,
    submittedData,
  ]);

  const handleChangeFilter = (field) => (event, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value || (event && event.target.value) || "",
    }));
  };

  const handleFilter = createFilterHandler({
    setLoading,
    setSubmittedData,
    setResults: setDeliveryReasons,
    showNotification,
    handleApiError,
    httpClient: httpclient,
    endpoint: `/delivery/order-reason`,
    fieldMappings,
    refresh,
  });

  const onFilterClick = () => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    handleFilter(filterData);
  };

  const handleRemove = (field) => {
    const newFilterData = { ...filterData };
    const newSubmittedData = { ...submittedData };

    newFilterData[field] = "";
    delete newSubmittedData[field];

    setFilterData(newFilterData);
    setSubmittedData(newSubmittedData);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    handleFilter(newFilterData);
  };

  const handleClearFilters = () => {
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleChangeStatus = async () => {
    setChangeStatus(true);
    const API_URL = `/delivery/order-reason/status/${selectedReason.id}`;

    try {
      const { data } = await httpclient.post(API_URL);

      if (data.status === 200) {
        showNotification("success", data.message);
        setSelectedReason(null);
        setOpenStatusChangeModal(false);
        fetchDeliveryReasons(
          paginationModel.page + 1,
          paginationModel.pageSize,
          submittedData,
          sortModel
        );
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      console.log(error, "error changing status");
      handleApiError(error);
    } finally {
      setChangeStatus(false);
    }
  };

  const handleDelete = async (reason) => {
    setSelectedReason(reason);
    setOpenDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    setDeleting(true);
    const API_URL = `/delivery/order-reason/delete/${selectedReason.id}`;

    try {
      const { data } = await httpclient.post(API_URL);

      if (data.status === 200) {
        showNotification("success", data.message);
        setOpenDeleteModal(false);
        setSelectedReason(null);
        fetchDeliveryReasons(
          paginationModel.page + 1,
          paginationModel.pageSize,
          submittedData,
          sortModel
        );
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      console.log(error, "error deleting reason");
      handleApiError(error);
    } finally {
      setDeleting(false);
    }
  };

  const handleAddReason = () => {
    navigate("/delivery/reasons/add", {
      state: { reasonTypes } // Pass reasonTypes to add page
    });
  };

  const handleEdit = (reason) => {
    setSelectedReason(reason);
    navigate(`/delivery/reasons/edit/${reason.id}`, {
      state: { reason, reasonTypes } // Pass reasonTypes to edit page
    });
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const columns = getColumns(
    setSelectedReason,
    setOpenStatusChangeModal,
    handleEdit,
    handleDelete
  );

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Delivery Order Reason
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            gap={2}
          >
            <img
              src={filterOpen ? FilterBtnUp : FilterBtn}
              alt="Filter"
              style={{ cursor: "pointer" }}
              onClick={() => setFilterOpen(!filterOpen)}
            />
            {allowAdd === 1 && (
              <Button
                variant="contained"
                sx={{
                  borderRadius: "4px",
                  backgroundColor: "#7152F3",
                  "&:hover": {
                    backgroundColor: "#5c34fa",
                  },
                }}
                startIcon={<GamesIcon />}
                onClick={handleAddReason}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    textTransform: "none",
                  }}
                >
                  Add New Reason
                </Typography>
              </Button>
            )}
          </Grid>
        </Grid>

        <Filter
          filterOpen={filterOpen}
          filterData={filterData}
          handleChangeFilter={handleChangeFilter}
          handleFilter={onFilterClick}
          handleClearFilters={handleClearFilters}
          handleRemove={handleRemove}
          submittedData={submittedData}
          reasonTypes={reasonTypes}
        />

        <DataGrid
          rows={deliveryReasons || []}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          loading={loading}
          slots={{
            loadingOverlay: CustomLoadingOverlay,
          }}
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            },
          }}
          paginationMode="server"
          sortingMode="server"
          onSortModelChange={handleSortModelChange}
          sortModel={sortModel}
          rowCount={rowCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
        />
        
        {openStatusChangeModal && (
          <StatusChangeConfirmationModal
            open={openStatusChangeModal}
            cancel={() => setOpenStatusChangeModal(false)}
            title="Change Status"
            item={selectedReason?.reason_name}
            loading={changeStatus}
            handleChangeStatus={handleChangeStatus}
          />
        )}

        {openDeleteModal && (
          <DeleteConfirmationModal
            open={openDeleteModal}
            cancel={() => setOpenDeleteModal(false)}
            title="Reason"
            item={selectedReason?.reason_name}
            loading={deleting}
            handleDelete={handleConfirmDelete}
          />
        )}
      </Box>
    </Box>
  );
}